// extracted by mini-css-extract-plugin
export default {"tabDashboardUsage":"TabDashboardUsage_tabDashboardUsage__cIXN9","rangeSelect":"TabDashboardUsage_rangeSelect__DdagP","card":"TabDashboardUsage_card__lKbBl"};